module.exports = __webpack_public_path__ + "static/img/hdhg.9a3a35f7.png";